'use strict';

export const ASSET_FILE_REQUIREMENT_COLLECTION = 'asset-file-requirements';
export const ASSET_FILE_REQUIREMENT_CLASS_NAME = 'AssetFileRequirementDomain';

export const ASSET_FORM_REQUIREMENT_COLLECTION = 'asset-form-requirements';
export const ASSET_FORM_REQUIREMENT_CLASS_NAME = 'AssetFormRequirementDomain';

export const FILE_REQUIREMENT_COLLECTION = 'file-requirements';
export const FILE_REQUIREMENT_CLASS_NAME = 'FileRequirementDomain';

export const FORM_REQUIREMENT_COLLECTION = 'form-requirements';
export const FORM_REQUIREMENT_CLASS_NAME = 'FormRequirementDomain';

export const FILE_ASSET_COLLECTION = 'file-assets';



// WEBPACK FOOTER //
// ./src/js/requirements/domain/config.js